import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'

const Footer = () => {
	return (
		<FooterContainer>
			<FooterLinksWrapper>
				<FooterDesc>
					<h1>Explore Naija</h1>
					<p>we strive to create the best experience for our customers</p>
				</FooterDesc>
				<FooterLinksItems>
					<FooterLinksTitle>Contact us</FooterLinksTitle>
					<FooterLink to="/about">Contact</FooterLink>
					<FooterLink to="/">Support</FooterLink>
					<FooterLink to="/">Destinations</FooterLink>
					<FooterLink to="/">Sponsorships</FooterLink>
				</FooterLinksItems>
			</FooterLinksWrapper>
			<FooterLinksWrapper>
				<FooterLinksItems>
					<FooterLinksTitle>Videos</FooterLinksTitle>
					<FooterLink to="/">Submit Video</FooterLink>
					<FooterLink to="/">Ambassedors</FooterLink>
					<FooterLink to="/">Agency</FooterLink>
					<FooterLink to="/">Influencers</FooterLink>
				</FooterLinksItems>
				
				<FooterLinksItems>
					<FooterLinksTitle>Social Medials</FooterLinksTitle>
					<FooterLink to="https://twitter.com/dudcally">Instagram</FooterLink>
					<FooterLink to="https://twitter.com/dudcally">Facebook</FooterLink>
					<FooterLink to="https://twitter.com/dudcally">Youtube</FooterLink>
					<FooterLink to="https://twitter.com/dudcally">Twitter</FooterLink>
				</FooterLinksItems>
			</FooterLinksWrapper>
		</FooterContainer>
  )
}
export default Footer

const FooterContainer = styled.div`
  padding: 5rem calc((100vw - 1100px) / 2 );
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  color: #000;
  background: #fafafb;

`

const FooterDesc = styled.div`
  padding: 0 2rem;

  h1 {
    margin-bottom: 3rem;
    color: #f26a2e;
  }

  @media screen and (max-width: 400px) {
    padding: 1rem;
  }
`

const FooterLinksWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);

  @media screen and (max-width: 820px) {
    grid-template-columns: 1fr;
  }
`

const FooterLinksItems = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 1rem 2rem;

  @media screen and (max-width: 400px) {
    padding: 1rem;
  }
`

const FooterLinksTitle = styled.h2`
  font-size: 14px;
  margin-bottom: 16px;
`

const FooterLink = styled(Link)`
  text-decoration: none;
  margin-bottom: 0.5rem;
  font-size:14px;
  color: #3d3d4e;

  &:hover {
    color: #f26a2e;
    transition: 0.3s ease-out;
  }
`